export default __webpack_public_path__ + "static/media/Brett Martinez.a9bd9830.jpg";